import { css as t } from "styled-components";
const s = {
  base: () => /* @__PURE__ */ t([
    "height:auto;width:100%;display:flex;flex-flow:row nowrap;"
  ]),
  cropped: ({ width: p }) => {
    const o = `${p * 100}%`;
    return /* @__PURE__ */ t([
      "svg{clip-path:polygon( 0 0,",
      " 0,",
      " 100%,0 100% );}"
    ], o, o);
  }
};
export {
  s as default
};
